<template>
    <Dialog modal header="Presupuestos AXA" :style="{width: '800px'}">
        <div>
            <div class="card card-default card-tabs" style="margin-bottom: 0;">
                <div class="card-header p-1 pt-1">
                    <ul class="nav nav-pills" ref="tabHeaders">
                        <li class="nav-item">
                            <a class="active nav-link" href="#temporales" data-toggle="tab">
                                Temporales
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#creados" data-toggle="tab">
                                Creados
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <br>
            <div class="tab-content" ref="tabContents">
                <div class="tab-pane active" id="temporales">                    
                    <div style="margin-top: 20px; display: grid; gap: 20px;"> 
                        <div v-if="cargandoTemporales">
                            <div class="loading-spinner">
                                <i class="fas fa-spinner fa-spin"></i> Cargando...
                            </div>
                        </div>
                        <div v-else-if="gruposAfectadosPresupuestosTemporales.length == 0">
                            No hay presupuestos temporales
                        </div>
                        <div v-else v-for="grupoAfectado in gruposAfectadosPresupuestosTemporales" :key="grupoAfectado.idAfectado" class="card card-primary">
                            <div class="card-header">
                                {{ grupoAfectado.afectado }}
                            </div>
                            <div class="card-body">
                                <div v-for="presupuesto in grupoAfectado.presupuestosTemporales" :key="presupuesto" class="card card-secondary">
                                    <div class="card-header">                                        
                                        {{ presupuesto.especialidad }} - Presupuestar por: {{ presupuesto.presupuestarPor }}                                                                                   
                                    </div>
                                    <div v-if="presupuesto.trabajos.length == 0 && presupuesto.materiales.length == 0" class="card-body">
                                        No hay trabajos ni materiales
                                    </div>
                                    <div v-else class="card-body">
                                        <div style="display: grid; gap: 15px">                                    
                                            <div>
                                                <label for="">Trabajos</label>
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                Categoria
                                                            </th>
                                                            <th>
                                                                Linea
                                                            </th>
                                                            <th>
                                                                Uds
                                                            </th>
                                                            <th>
                                                                Precio
                                                            </th>
                                                            <th>
                                                                IVA (%)
                                                            </th>
                                                            <th>
                                                                Total
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="trabajo in presupuesto.trabajos" :key="trabajo">
                                                            <td>
                                                                {{ trabajo.trabajo.nombre_categoria }}
                                                            </td>
                                                            <td>
                                                                {{ trabajo.trabajo.desc_linea }}
                                                            </td>
                                                            <td>
                                                                {{ trabajo.Cantidad }}
                                                            </td>
                                                            <td>
                                                                {{ trabajo.TotalSinIva }}
                                                            </td>
                                                            <td>
                                                                {{ trabajo.IvaSeleccionado }}
                                                            </td>
                                                            <td>
                                                                {{ trabajo.TotalConIva }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div>
                                                <label for="">Materiales</label>
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                Tipo
                                                            </th>
                                                            <th>
                                                                Descripción
                                                            </th>
                                                            <th>
                                                                Uds
                                                            </th>
                                                            <th>
                                                                Precio
                                                            </th>
                                                            <th>
                                                                IVA (%)
                                                            </th>
                                                            <th>
                                                                Total
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="material in presupuesto.materiales" :key="material">
                                                            <td>
                                                                otros
                                                            </td>
                                                            <td>
                                                                {{ material.Descripcion }}
                                                            </td>
                                                            <td>
                                                                {{ material.Cantidad }}
                                                            </td>
                                                            <td>
                                                                {{ material.trabajo.precioUnidad }}
                                                            </td>
                                                            <td>
                                                                {{ material.IvaSeleccionado }}
                                                            </td>
                                                            <td>
                                                                {{ material.TotalConIva }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>       
                                            <div v-if="presupuesto.presupuestarPor == 'M.O.'">
                                                <label for="">Desplazamiento</label>
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                Kms
                                                            </th>
                                                            <th>
                                                                Mínimo
                                                            </th>
                                                            <th>
                                                                Kms netos
                                                            </th>
                                                            <th>
                                                                Precio
                                                            </th>
                                                            <th>
                                                                IVA (%)
                                                            </th>
                                                            <th>
                                                                Total
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="desplazamiento in presupuesto.desplazamiento" :key="desplazamiento">
                                                            <td>
                                                                {{ desplazamiento.Cantidad }}
                                                            </td>
                                                            <td>
                                                                {{ desplazamiento.trabajo.minKmFacturables }}
                                                            </td>
                                                            <td>
                                                                {{ desplazamiento.trabajo.unidadesAFacturar }}
                                                            </td>
                                                            <td>
                                                                {{ desplazamiento.trabajo.precio }}
                                                            </td>
                                                            <td>
                                                                {{ desplazamiento.IvaSeleccionado }}
                                                            </td>
                                                            <td>
                                                                {{ desplazamiento.TotalConIva }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div style="margin: 15px 0;">
                                                <label for="">TOTAL OFICIO</label>
                                                <table v-if="presupuesto.presupuestarPor=='baremo'" class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                Baremo
                                                            </th>
                                                            <th>
                                                                MATS.
                                                            </th>
                                                            <th>
                                                                IVA(%)
                                                            </th>
                                                            <th>
                                                                TOTAL
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                {{ presupuesto.totalBaremo }}
                                                            </td>
                                                            <td>
                                                                {{ presupuesto.totalMateriales }}
                                                            </td>
                                                            <td>
                                                                {{ presupuesto.totalIva }}
                                                            </td>
                                                            <td>
                                                                {{ presupuesto.total }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <table v-else class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                M.O.
                                                            </th>
                                                            <th>
                                                                MATS.
                                                            </th>
                                                            <th>
                                                                DESPL.
                                                            </th>
                                                            <th>
                                                                IVA (€)
                                                            </th>
                                                            <th>
                                                                TOTAL
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                {{ presupuesto.totalBaremo }}
                                                            </td>
                                                            <td>
                                                                {{ presupuesto.totalMateriales }}
                                                            </td>
                                                            <td>
                                                                {{ presupuesto.totalDesplazamiento }}
                                                            </td>
                                                            <td>
                                                                {{ presupuesto.totalIva }}
                                                            </td>
                                                            <td>
                                                                {{ presupuesto.total }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div> 
                                            <div>
                                                <label for="">Comentario</label>
                                                <textarea v-model="presupuesto.comentario" rows="2" class="form-control" id=""></textarea>
                                            </div>
                                        </div>                                
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">                                                            
                                <div style="display: flex; justify-content: end;align-items: end;">
                                    <button class="btn btn-primary" @click="guardarPresupuesto(grupoAfectado)">Guardar presupuesto</button>
                                </div>
                            </div>
                        </div>                       
                    </div>
                </div>
                <div class="tab-pane" id="creados">
                    <div v-if="cargandoCreados">
                        <div class="loading-spinner">
                            <i class="fas fa-spinner fa-spin"></i> Cargando...
                        </div>
                    </div>       
                    <div v-else-if="gruposAfectadosPresupuestosCreados.length == 0">
                        No hay presupuestos creados
                    </div>
                    <div v-else>
                        <div style="margin-top: 20px; display: grid; gap: 20px;"> 
                            <div v-for="grupoAfectado in gruposAfectadosPresupuestosCreados" :key="grupoAfectado.idAfectado" class="card card-primary">
                                <div class="card-header">
                                    {{ grupoAfectado.afectado }}
                                </div>
                                <div class="card-body">
                                    <div class="card card-secondary" v-for="presupuesto in grupoAfectado.presupuestosCreados" :key="presupuesto">
                                        <div class="card-header">
                                            <div style="display: flex; justify-content: space-between">
                                                <h5 class="card-title">
                                                    Nº:{{ presupuesto.id_presupuesto }}-{{ presupuesto.version }} Importe: {{ presupuesto.total }}€ Estado: {{ presupuesto.estado }}
                                                </h5>
                                                <div style="display: flex;gap: 5px;">
                                                    <!-- <button @click="guardarPresupuesto(grupoAfectado, presupuesto)" class="btn btn-sm btn-primary"><i class="fas fa-save"></i></button> -->
                                                    <button v-if="presupuesto.id_estado != 4" class="btn btn-sm btn-danger" @click="confirmarEliminarPresupuesto(grupoAfectado,presupuesto)"><i class="fas fa-times"></i></button>
                                                    <button class="btn btn-tool ampliar-asegurado" v-on:click="presuVisible[presupuesto.id_presupuesto] = !presuVisible[presupuesto.id_presupuesto]" v-if="!presuVisible[presupuesto.id_presupuesto]">
                                                        <i class="fas fa-plus"></i>
                                                    </button>
                                                    <button class="btn btn-tool reducir-asegurado" v-on:click="presuVisible[presupuesto.id_presupuesto] = !presuVisible[presupuesto.id_presupuesto]" v-if="presuVisible[presupuesto.id_presupuesto]">
                                                        <i class="fas fa-minus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body" v-if="presuVisible[presupuesto.id_presupuesto] == true">
                                            <div style="display: flex; justify-content: end;gap: 10px; margin-bottom: 10px;">
                                                <button @click="confirmarAccionPresupuesto(grupoAfectado, presupuesto, 'SOL_AUTORIZ')" class="btn btn-sm btn-light" style="border: 1px solid grey;" v-if="presupuesto.id_estado == 8 || presupuesto.id_estado == 7">
                                                    Solicitar autorización
                                                </button>
                                                <button @click="confirmarAccionPresupuesto(grupoAfectado, presupuesto, 'ACEPTAR_PPTO')" class="btn btn-sm btn-light" style="border: 1px solid grey;" v-if="presupuesto.id_estado == 6">
                                                    Aceptar presupuesto
                                                </button>
                                                <button @click="confirmarAccionPresupuesto(grupoAfectado, presupuesto, 'TERMINAR_PPTO')" class="btn btn-sm btn-light" style="border: 1px solid grey;" v-if="presupuesto.id_estado == 1 && presupuesto.tiene_visita == false && presupuesto.tiene_desp == false && presupuesto.tipo_encargo == 'particular'">
                                                    Terminar presupuesto
                                                </button>
                                                <button disabled title="Para facturar ir a la pestaña del servicio de facturación" @click="confirmarAccionPresupuesto(grupoAfectado, presupuesto, 'FACTURAR')" v-else-if="presupuesto.id_estado == 1" class="btn btn-sm btn-light" style="border: 1px solid grey;">
                                                    Facturar
                                                </button>
                                                <button disabled title="Para facturar ir a la pestaña del servicio de facturación" @click="confirmarAccionPresupuesto(grupoAfectado, presupuesto, 'FACTURAR')" v-else-if="presupuesto.id_estado == 3 && presupuesto.tipo_encargo == 'normal'" class="btn btn-sm btn-light" style="border: 1px solid grey;">
                                                    Facturar
                                                </button>
                                                <button @click="confirmarAccionPresupuesto(grupoAfectado, presupuesto, 'GEN_FACTURA')" class="btn btn-sm btn-light" style="border: 1px solid grey;" v-if="presupuesto.id_estado == 4">
                                                    Generar factura
                                                </button>
                                            </div>
                                            <div v-for="especialidad in presupuesto.especialidades" :key="especialidad" class="card">
                                                <div class="card-header">
                                                    <div style="display: flex; justify-content: space-between;">
                                                        <h6 class="card-title">
                                                            {{ especialidad.especialidad }} - Presupuestar por: {{ especialidad.presupuestarPor }}                                                                                  
                                                        </h6>
                                                        <button v-if="presupuesto.id_estado != 4" @click="confirmarEliminarEspecialidadPresupuesto(grupoAfectado, presupuesto, especialidad)" class="btn btn-sm btn-danger"><i class="fas fa-times"></i></button>
                                                    </div>                                  
                                                </div>
                                                <div v-if="especialidad.trabajos.length == 0 && especialidad.materiales.length == 0" class="card-body">
                                                    No hay trabajos ni materiales
                                                </div>
                                                <div v-else class="card-body">
                                                    <div style="display: grid; gap: 15px">                                    
                                                        <div>
                                                            <label for="">Trabajos</label>
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Categoria
                                                                        </th>
                                                                        <th>
                                                                            Linea
                                                                        </th>
                                                                        <th>
                                                                            Uds
                                                                        </th>
                                                                        <th>
                                                                            Precio
                                                                        </th>
                                                                        <th>
                                                                            IVA (%)
                                                                        </th>
                                                                        <th>
                                                                            Total
                                                                        </th>
                                                                        <th>
                                                                            
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="trabajo in especialidad.trabajos" :key="trabajo">
                                                                        <td>
                                                                            {{ trabajo.trabajo.nombre_categoria }}
                                                                        </td>
                                                                        <td>
                                                                            {{ trabajo.trabajo.desc_linea }}
                                                                        </td>
                                                                        <td>
                                                                            {{ trabajo.Cantidad }}
                                                                        </td>
                                                                        <td>
                                                                            {{ trabajo.TotalSinIva }}
                                                                        </td>
                                                                        <td>
                                                                            {{ trabajo.IvaSeleccionado }}
                                                                        </td>
                                                                        <td>
                                                                            {{ trabajo.TotalConIva }}
                                                                        </td>
                                                                        <td>
                                                                            <button v-if="presupuesto.id_estado != 4" class="btn btn-sm btn-danger" @click="confirmarEliminarTrabajoPresupuesto(grupoAfectado, presupuesto, especialidad, trabajo)"><i class="fas fa-times"></i></button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div>
                                                            <label for="">Materiales</label>
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Categoria
                                                                        </th>
                                                                        <th>
                                                                            Linea
                                                                        </th>
                                                                        <th>
                                                                            Uds
                                                                        </th>
                                                                        <th>
                                                                            Precio
                                                                        </th>
                                                                        <th>
                                                                            IVA (%)
                                                                        </th>
                                                                        <th>
                                                                            Total
                                                                        </th>
                                                                        <th></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="material in especialidad.materiales" :key="material">
                                                                        <td>
                                                                            {{ material.trabajo.nombre_categoria }}
                                                                        </td>
                                                                        <td>
                                                                            {{ material.trabajo.desc_linea }}
                                                                        </td>
                                                                        <td>
                                                                            {{ material.Cantidad }}
                                                                        </td>
                                                                        <td>
                                                                            {{ material.trabajo.precioUnidad }}
                                                                        </td>
                                                                        <td>
                                                                            {{ material.IvaSeleccionado }}
                                                                        </td>
                                                                        <td>
                                                                            {{ material.TotalConIva }}
                                                                        </td>
                                                                        <td>
                                                                            <button v-if="presupuesto.id_estado != 4" class="btn btn-sm btn-danger" @click="confirmarEliminarTrabajoPresupuesto(grupoAfectado, presupuesto, especialidad, material)"><i class="fas fa-times"></i></button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div v-if="especialidad.presupuestarPor == 'M.O.'">
                                                            <label for="">Desplazamiento</label>
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Kms
                                                                        </th>
                                                                        <th>
                                                                            Mínimo
                                                                        </th>
                                                                        <th>
                                                                            Kms netos
                                                                        </th>
                                                                        <th>
                                                                            Precio
                                                                        </th>
                                                                        <th>
                                                                            IVA (%)
                                                                        </th>
                                                                        <th>
                                                                            Total
                                                                        </th>
                                                                        <th></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="desplazamiento in especialidad.desplazamiento" :key="desplazamiento">
                                                                        <td>
                                                                            {{ desplazamiento.Cantidad }}
                                                                        </td>
                                                                        <td>
                                                                            {{ desplazamiento.trabajo.minKmFacturables }}
                                                                        </td>
                                                                        <td>
                                                                            {{ desplazamiento.trabajo.unidadesAFacturar }}
                                                                        </td>
                                                                        <td>
                                                                            {{ desplazamiento.trabajo.precio }}
                                                                        </td>
                                                                        <td>
                                                                            {{ desplazamiento.IvaSeleccionado }}
                                                                        </td>
                                                                        <td>
                                                                            {{ desplazamiento.TotalConIva }}
                                                                        </td>
                                                                        <td>
                                                                            <button v-if="presupuesto.id_estado != 4" class="btn btn-sm btn-danger" @click="confirmarEliminarTrabajoPresupuesto(grupoAfectado, presupuesto, especialidad, desplazamiento)"><i class="fas fa-times"></i></button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div style="margin: 15px 0;">
                                                            <label for="">TOTAL OFICIO</label>
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Baremo
                                                                        </th>
                                                                        <th>
                                                                            MATS.
                                                                        </th>
                                                                        <th>
                                                                            IVA(€)
                                                                        </th>
                                                                        <th>
                                                                            TOTAL
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>
                                                                            {{ especialidad.totalBaremo }}
                                                                        </td>
                                                                        <td>
                                                                            {{ especialidad.totalMateriales }}
                                                                        </td>
                                                                        <td>
                                                                            {{ especialidad.totalIva }}
                                                                        </td>
                                                                        <td>
                                                                            {{ especialidad.total }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div> 
                                                        <div>
                                                            <label for="">Comentario</label>
                                                            <textarea v-model="especialidad.comentario" rows="2" class="form-control" id=""></textarea>
                                                        </div>
                                                    </div>                                
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                            </div>                       
                        </div>               
                    </div>
                </div>
            </div>
            <div style="display: flex; border-top: 1px solid grey; margin-top: 10px; justify-content: end;">
                <button class="btn btn-light btn-sm" style="border: 1px solid; margin-top: 15px;" @click="$emit('cerrar')">Cerrar</button>
            </div>       
        </div>
    </Dialog>
</template>

<script>
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    props: ['id', 'oficios'],
    components: {
    },
    data() {
        return {
            cargandoTemporales:false,
            cargandoCreados:false,
            presuVisible:[],
            afectadosPresupuestos:[],
            gruposAfectadosPresupuestosTemporales:[],
            gruposAfectadosPresupuestosCreados:[],
        };
    },
    methods: {
        confirmarAccionPresupuesto(afectado, presupuesto, accion){
            this.$confirm.require({
                 message: '¿Está seguro de realizar la acción?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                    this.accionPresupuesto(afectado, presupuesto, accion);
                },
                reject: () => {
                    return;
                }
            });
        },
        async accionPresupuesto(afectado, presupuesto, accion){
            const api = new PwgsApi();
            var envio = {
                TipoOperacion:accion,
                TipoPrepVal:"P",
                IdEncargo:"",
                IdAfectado:afectado.idAfectado,
                IdPrepVal:presupuesto.id_presupuesto,
                Version:presupuesto.version,
            }
            try{
                this.cargandoCreados = true;
                await api.post('servicios/' + this.id + '/accion-presuval', {envio:envio});
                if(envio.TipoOperacion == 'GEN_FACTURA'){
                    this.$toast.add({severity:'success', summary: 'Modificada', detail: 'Se ha generado el documento de la factura. En breve podrá consultarlo mediante el servicio de consulta de documentos', life: 5000});
                }else{
                    this.$toast.add({severity:'success', summary: 'Modificado', detail: 'Presupuesto modificado', life: 2000});
                }
                this.cargarTrabajos();
            }catch(e){
                this.cargandoCreados = false;
                this.$toast.add({severity: 'error', summary: 'Error', detail: e, life: 5000 });
                console.error(e);
            }
        },
        confirmarEliminarTrabajoPresupuesto(afectado, presupuesto, especialidad, trabajo){
            this.$confirm.require({
                message: 'Se eliminará el trabajo del presupuesto',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                    this.eliminarTrabajoPresupuesto(afectado, presupuesto, especialidad, trabajo);
                },
                reject: () => {
                    return;
                }
            });
        },
        async eliminarTrabajoPresupuesto(afectadoElim, presupuestoElim, especialidadElim, trabajoElim){
            const api = new PwgsApi();
            console.log('presupuestoelim', presupuestoElim);
            console.log('especialidadelim', especialidadElim);
            console.log('trabajoelim', trabajoElim);
            console.log('afectadoelim', afectadoElim);            
            var idsTrabajos = [];            
            var oficios = [];
            for(let especialidad of presupuestoElim.especialidades){                
                var oficio ={
                    PresupuestarPor: especialidad.presupuestarPor,
                    IdEspecialidad: especialidad.idEspecialidad,
                    Indice: especialidad.indice,
                    Comentario: especialidad.comentario,
                    IdProfesion: especialidad.idProfesion,
                    IvaReducido:'',
                    IVAOfic:'',
                    Trabajos:[],
                    Materiales:[],
                }
                if(especialidad.trabajos && especialidad.trabajos.length > 0){
                    for(let trabajo of especialidad.trabajos){
                        if(trabajo.trabajo.clave_linea != trabajoElim.trabajo.clave_linea){
                            idsTrabajos.push(trabajo.id_trabajo);
                            if(trabajo.PresupuestarPor == 'BA'){
                                oficio.PresupuestarPor = 'BA';
                            }else{
                                oficio.PresupuestarPor = 'MO';
                            }
                            if(trabajo.IvaReducido == 'N'){
                                oficio.IvaReducido = 'N';
                            }else{
                                oficio.IvaReducido = 'S';
                            }
                            oficio.IVAOfic = trabajo.IvaSeleccionado;                        
                            var precio2 = trabajo.trabajo.precio;
                            var trabajoOficio = {
                                IdTarifa:trabajo.trabajo.id_tarifa,
                                IdTraOfic:trabajo.trabajo.id_categoria,
                                IdLinea:trabajo.trabajo.id_linea,
                                ClaveLinea:trabajo.trabajo.clave_linea,
                                Cantidad:trabajo.Cantidad.toString().replaceAll('.',','),
                                Precio:precio2.toString().replaceAll('.',','),
                                IVABarMO:trabajo.IvaSeleccionado,
                                Urgente:trabajo.Urgente,
                                TotalConIVABarMO:trabajo.TotalConIva.toString().replaceAll('.',','),
                            }
                            oficio.Trabajos.push(trabajoOficio);
                        }
                    }
                }
                if(especialidad.materiales && especialidad.materiales.length > 0){
                    for(let material of especialidad.materiales){
                        if(material.trabajo.clave_linea != trabajoElim.trabajo.clave_linea || especialidad.idEspecialidad != especialidadElim.idEspecialidad){
                            idsTrabajos.push(material.trabajo.id_trabajo);
                            var precio = 0;
                            if(material.PresupuestarPor == 'BA'){
                                precio = material.trabajo.precioUnidad;
                                oficio.PresupuestarPor = 'BA';
                            }else{
                                precio = material.trabajo.precioUnidad;
                                oficio.PresupuestarPor = 'MO';
                            }
                            if(material.IvaReducido == 'N'){
                                oficio.IvaReducido = 'N';
                            }else{
                                oficio.IvaReducido = 'S';
                            }
                            oficio.IVAOfic = material.IvaSeleccionado;
                            var materialOficio = {
                                IdTarifa:material.trabajo.id_tarifa,
                                IdTraOfic:material.trabajo.id_categoria,
                                IdLinea:material.trabajo.id_linea,
                                ClaveLinea:material.trabajo.clave_linea,
                                Cantidad:material.Cantidad.toString().replaceAll('.',','),
                                Precio:precio.toString().replaceAll(".", ","),
                                IVAMat:material.IvaSeleccionado,
                                Descripcion:material.Descripcion,
                                TotalConIVAMat:material.TotalConIva.toString().replaceAll('.',','),
                            }
                            oficio.Materiales.push(materialOficio);
                        }
                    }
                }                
                if(especialidad.desplazamiento && especialidad.desplazamiento.length > 0){
                    var desplazamiento = especialidad.desplazamiento[0];
                    console.log('desplazamiento', desplazamiento);
                     oficio.Desplazamiento = {
                        IdTarifa:desplazamiento.trabajo.id_tarifa,
                        IdTraOfic:desplazamiento.trabajo.id_categoria,
                        IdLinea:desplazamiento.trabajo.id_linea,
                        ClaveLinea:desplazamiento.trabajo.clave_linea,
                        Kms:desplazamiento.Cantidad,
                        KmsPrecio:desplazamiento.trabajo.precio.toString().replaceAll(".", ","),
                        IVAKms:desplazamiento.IvaSeleccionado,
                        TotalConIVAKms:desplazamiento.TotalConIva.toString().replaceAll('.',',')
                    }
                }
                if(oficio.Trabajos.length > 0 || oficio.Materiales.length > 0 || oficio.Desplazamiento){
                    oficios.push(oficio);                
                }
            }
            var envio = {
                TipoOperacion:"MANAGE_PREVAL",
                TipoPrepVal:"P",
                IdEncargo:"",
                IdAfectado:afectadoElim.idAfectado,
                Oficios:oficios,
                IdPrepVal:presupuestoElim.id_presupuesto,
                Version:presupuestoElim.version       
            }
            try{
                console.log('envio', envio);
                var resp = await api.post('servicios/'+ this.id + '/envio-presuval', {envio:envio}); 
                console.log('respobtenida', resp);
                var presupuesto = resp['RepairEstimateValuationList']['Presupuestos']['ListadoPresupuestos'][0]['Presupuesto'][0];
                console.log('presupuestoobtenido', presupuesto);
                this.$toast.add({severity:'success', summary: 'Creado', detail: 'Presupuesto modificado', life: 2000});   
                if(presupuesto && idsTrabajos.length > 0){
                    await api.put('trabajos/'+ this.id +'/marcar-enviados', {ids:idsTrabajos, id_presuval:presupuesto.IdPPTOVAL, version:presupuesto.Version});
                }             
                if(especialidadElim.trabajos && especialidadElim.trabajos.length > 0){                    
                    for(let trabajo of especialidadElim.trabajos){
                        if(trabajo.trabajo.clave_linea == trabajoElim.trabajo.clave_linea){
                            var dat = await api.get('trabajos/' + trabajo.id_trabajo);
                            var datosTrabajo = dat.datos;
                            var tipo = 'cliente';
                            if(datosTrabajo.destinatario_trabajo != 'Compañia' && datosTrabajo.destinatario_trabajo != ''){
                                tipo = 'opera';
                            }
                            let subidadatos = { baremos_trabajos_id_trabajo: 0, quitar_baremo: 1 };
                            await api.put('trabajos/' + trabajo.id_trabajo + '/modificar-trabajo', subidadatos);
                            console.log('tipo', tipo);
                            this.$parent.togglerecargar(datosTrabajo, true, false, tipo);                        
                        }
                    }
                }
                if(especialidadElim.materiales && especialidadElim.materiales.length > 0){
                    for(let material of especialidadElim.materiales){
                        if(material.trabajo.clave_linea == trabajoElim.trabajo.clave_linea){
                            var dat2 = await api.get('trabajos/' + material.id_trabajo);
                            var datosTrabajo2 = dat2.datos;
                            var tipo2 = 'cliente';
                            if(datosTrabajo2.destinatario_trabajo != 'Compañia' && datosTrabajo2.destinatario_trabajo != ''){
                                tipo = 'opera';
                            }
                            let subidadatos = { baremos_trabajos_id_trabajo: 0, quitar_baremo: 1 };
                            await api.put('trabajos/' + material.id_trabajo + '/modificar-trabajo', subidadatos);
                            console.log('tipo', tipo2);
                            this.$parent.togglerecargar(datosTrabajo2, true, false, tipo2);                        
                        }
                    }
                }
                if(especialidadElim.desplazamiento && especialidadElim.desplazamiento.length > 0){
                    for(let desplazamiento of especialidadElim.desplazamiento){
                        if(desplazamiento.trabajo.clave_linea == trabajoElim.trabajo.clave_linea){
                            var dat3 = await api.get('trabajos/' + desplazamiento.id_trabajo);
                            var datosTrabajo3 = dat3.datos;
                            var tipo3 = 'cliente';
                            if(datosTrabajo3.destinatario_trabajo != 'Compañia' && datosTrabajo3.destinatario_trabajo != ''){
                                tipo = 'opera';
                            }
                            let subidadatos = { baremos_trabajos_id_trabajo: 0, quitar_baremo: 1 };
                            await api.put('trabajos/' + desplazamiento.id_trabajo + '/modificar-trabajo', subidadatos);
                            console.log('tipo', tipo3);
                            this.$parent.togglerecargar(datosTrabajo3, true, false, tipo3);                        
                        }
                    }
                }
                console.log('llegavareca');
                this.cargarTrabajos();
            }catch(e){
                this.$toast.add({severity:'error', summary: 'Error', detail: e, life: 5000});
                console.error(e);
            }
        },
        confirmarEliminarPresupuesto(afectado, presupuesto){
            this.$confirm.require({
                message: 'Se eliminará el presupuesto',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                    this.eliminarPresupuesto(afectado, presupuesto);
                },
                reject: () => {
                    return;
                }
            });
        },
        //eliminamos el presupuesto, enviandolo sin oficios y liberamos los trabajos de nuestra app enlazados a los baremos eliminados de axa
        async eliminarPresupuesto(afectadoElim, presupuestoElim){
            const api = new PwgsApi();
            console.log('presupuesto', presupuestoElim);
            var envio = {
                TipoOperacion:"MANAGE_PREVAL",
                TipoPrepVal:"P",
                IdEncargo:"",
                IdAfectado:afectadoElim.idAfectado,
                Oficios:[],
                IdPrepVal:presupuestoElim.id_presupuesto,
                Version:presupuestoElim.version       
            }
            try{
                var resp = await api.post('servicios/'+ this.id + '/envio-presuval', {envio:envio}); 
                console.log('respobtenida', resp);
                var presupuesto = resp['RepairEstimateValuationList']['Presupuestos']['ListadoPresupuestos'][0]['Presupuesto'][0];
                console.log('presupuestoobtenido', presupuesto);
                this.$toast.add({severity:'success', summary: 'Creado', detail: 'Presupuesto modificado', life: 2000});  
                
                for(let especialidad of presupuestoElim.especialidades){
                    if(especialidad.trabajos && especialidad.trabajos.length > 0){
                        for(let trabajo of especialidad.trabajos){
                            var dat = await api.get('trabajos/' + trabajo.id_trabajo);
                            var datosTrabajo = dat.datos;
                            var tipo = 'cliente';
                            if(datosTrabajo.destinatario_trabajo != 'Compañia' && datosTrabajo.destinatario_trabajo != ''){
                                tipo = 'opera';
                            }
                            let subidadatos = { baremos_trabajos_id_trabajo: 0, quitar_baremo: 1 };
                            await api.put('trabajos/' + trabajo.id_trabajo + '/modificar-trabajo', subidadatos);
                            console.log('tipo', tipo);
                            this.$parent.togglerecargar(datosTrabajo, true, false, tipo);
                        }
                    }
                    if(especialidad.materiales && especialidad.materiales.length > 0){
                        for(let material of especialidad.materiales){
                            var dat2 = await api.get('trabajos/' + material.id_trabajo);
                            var datosTrabajo2 = dat2.datos;
                            var tipo2 = 'cliente';
                            if(datosTrabajo2.destinatario_trabajo != 'Compañia' && datosTrabajo2.destinatario_trabajo != ''){
                                tipo = 'opera';
                            }
                            let subidadatos = { baremos_trabajos_id_trabajo: 0, quitar_baremo: 1 };
                            await api.put('trabajos/' + material.id_trabajo + '/modificar-trabajo', subidadatos);
                            console.log('tipo', tipo2);
                            this.$parent.togglerecargar(datosTrabajo2, true, false, tipo2);
                        }
                    }
                    if(especialidad.desplazamiento && especialidad.desplazamiento.length > 0){
                        for(let desplazamiento of especialidad.desplazamiento){
                            var dat3 = await api.get('trabajos/' + desplazamiento.id_trabajo);
                            var datosTrabajo3 = dat3.datos;
                            var tipo3 = 'cliente';
                            if(datosTrabajo3.destinatario_trabajo != 'Compañia' && datosTrabajo3.destinatario_trabajo != ''){
                                tipo = 'opera';
                            }
                            let subidadatos = { baremos_trabajos_id_trabajo: 0, quitar_baremo: 1 };
                            await api.put('trabajos/' + desplazamiento.id_trabajo + '/modificar-trabajo', subidadatos);
                            console.log('tipo', tipo3);
                            this.$parent.togglerecargar(datosTrabajo3, true, false, tipo3);
                        }
                    }
                }
                this.cargarTrabajos();
            }catch(e){
                this.$toast.add({severity:'error', summary: 'Error', detail: e, life: 5000});
                console.error(e);
            }
        },
        confirmarEliminarEspecialidadPresupuesto(afectado, presupuesto, especialidad){
            this.$confirm.require({
                message: 'Se eliminará el oficio para el presupuesto',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                    this.eliminarEspecialidadPresupuesto(afectado, presupuesto, especialidad);
                },
                reject: () => {
                    return;
                }
            });
        },

        //actualizamos el presupuesto, enviandolo sin el oficio que se va a eliminar, actualizamos la versión de los trabajos pertenecientes al presupuesto,
        //ya que al actualizar, se crea una nueva versión y por último liberamos los trabajos de nuestra app enlazados a los baremos eliminados de axa
        async eliminarEspecialidadPresupuesto(afectado, presupuestoElim, especialidadElim){
            const api = new PwgsApi();
            console.log('presupuesto', presupuestoElim);
            console.log('especialidad', especialidadElim);   
            var idsTrabajos = [];            
            var oficios = [];
            for(let especialidad of presupuestoElim.especialidades){
                if(especialidad.idEspecialidad != especialidadElim.idEspecialidad){
                    var oficio ={
                        PresupuestarPor: especialidad.presupuestarPor,
                        IdEspecialidad: especialidad.idEspecialidad,
                        Indice: especialidad.indice,
                        Comentario: especialidad.comentario,
                        IdProfesion: especialidad.idProfesion,
                        IvaReducido:'',
                        IVAOfic:'',
                        Trabajos:[],
                        Materiales:[],
                    }
                    if(especialidad.trabajos && especialidad.trabajos.length > 0){
                        for(let trabajo of especialidad.trabajos){
                            idsTrabajos.push(trabajo.id_trabajo);
                            if(trabajo.PresupuestarPor == 'BA'){
                                oficio.PresupuestarPor = 'BA';
                            }else{
                                oficio.PresupuestarPor = 'MO';
                            }
                            if(trabajo.IvaReducido == 'N'){
                                oficio.IvaReducido = 'N';
                            }else{
                                oficio.IvaReducido = 'S';
                            }
                            oficio.IVAOfic = trabajo.IvaSeleccionado;                        
                            var precio2 = trabajo.trabajo.precio;
                            var trabajoOficio = {
                                IdTarifa:trabajo.trabajo.id_tarifa,
                                IdTraOfic:trabajo.trabajo.id_categoria,
                                IdLinea:trabajo.trabajo.id_linea,
                                ClaveLinea:trabajo.trabajo.clave_linea,
                                Cantidad:trabajo.Cantidad.toString().replaceAll('.',','),
                                Precio:precio2.toString().replaceAll('.',','),
                                IVABarMO:trabajo.IvaSeleccionado,
                                Urgente:trabajo.Urgente,
                                TotalConIVABarMO:trabajo.TotalConIva.toString().replaceAll('.',','),
                            }
                            oficio.Trabajos.push(trabajoOficio);
                        }
                    }
                    if(especialidad.materiales && especialidad.materiales.length > 0){                        
                        for(let material of especialidad.materiales){
                            idsTrabajos.push(material.trabajo.id_trabajo);
                            var precio = 0;
                            if(material.PresupuestarPor == 'BA'){
                                precio = material.trabajo.precioUnidad;
                                oficio.PresupuestarPor = 'BA';
                            }else{
                                precio = material.trabajo.precioUnidad;
                                oficio.PresupuestarPor = 'MO';
                            }
                            if(material.IvaReducido == 'N'){
                                oficio.IvaReducido = 'N';
                            }else{
                                oficio.IvaReducido = 'S';
                            }
                            oficio.IVAOfic = material.IvaSeleccionado;  
                            var materialOficio = {
                                IdTarifa:material.trabajo.id_tarifa,
                                IdTraOfic:material.trabajo.id_categoria,
                                IdLinea:material.trabajo.id_linea,
                                ClaveLinea:material.trabajo.clave_linea,
                                Cantidad:material.Cantidad.toString().replaceAll('.',','),
                                Precio:precio.toString().replaceAll(".", ","),
                                IVAMat:material.IvaSeleccionado,
                                Descripcion:material.Descripcion,
                                TotalConIVAMat:material.TotalConIva.toString().replaceAll('.',','),
                            }
                            oficio.Materiales.push(materialOficio);
                        }
                    }
                    if(especialidad.desplazamiento && especialidad.desplazamiento.length > 0){                        
                        if(especialidad.desplazamiento.length > 0){
                            var desplazamiento = especialidad.desplazamiento[0];
                            
                            oficio.Desplazamiento = {
                                IdTarifa:desplazamiento.trabajo.id_tarifa,
                                IdTraOfic:desplazamiento.trabajo.id_categoria,
                                IdLinea:desplazamiento.trabajo.id_linea,
                                ClaveLinea:desplazamiento.trabajo.clave_linea,
                                Kms:desplazamiento.Cantidad,
                                KmsPrecio:desplazamiento.trabajo.precio.toString().replaceAll(".", ","),
                                IVAKms:desplazamiento.IvaSeleccionado,
                                TotalConIVAKms:desplazamiento.TotalConIva.toString().replaceAll('.',',')
                            }
                        }
                    }
                    oficios.push(oficio);
                }
            }
            var envio = {
                TipoOperacion:"MANAGE_PREVAL",
                TipoPrepVal:"P",
                IdEncargo:"",
                IdAfectado:afectado.idAfectado,
                Oficios:oficios,
                IdPrepVal:presupuestoElim.id_presupuesto,
                Version:presupuestoElim.version       
            }

            try{
                var resp = await api.post('servicios/'+ this.id + '/envio-presuval', {envio:envio}); 
                console.log('respobtenida', resp);
                var presupuesto = resp['RepairEstimateValuationList']['Presupuestos']['ListadoPresupuestos'][0]['Presupuesto'][0];
                console.log('presupuestoobtenido', presupuesto);
                this.$toast.add({severity:'success', summary: 'Creado', detail: 'Presupuesto modificado', life: 2000});   
                if(presupuesto && idsTrabajos.length > 0){
                    await api.put('trabajos/'+ this.id +'/marcar-enviados', {ids:idsTrabajos, id_presuval:presupuesto.IdPPTOVAL, version:presupuesto.Version});
                }

                if(especialidadElim.trabajos && especialidadElim.trabajos.length > 0){
                    for(let trabajo of especialidadElim.trabajos){
                        var dat = await api.get('trabajos/' + trabajo.id_trabajo);
                        var datosTrabajo = dat.datos;
                        var tipo = 'cliente';
                        if(datosTrabajo.destinatario_trabajo != 'Compañia' && datosTrabajo.destinatario_trabajo != ''){
                            tipo = 'opera';
                        }
                        let subidadatos = { baremos_trabajos_id_trabajo: 0, quitar_baremo: 1 };
                        await api.put('trabajos/' + trabajo.id_trabajo + '/modificar-trabajo', subidadatos);
                        console.log('tipo', tipo);
                        this.$parent.togglerecargar(datosTrabajo, true, false, tipo);
                    }
                }
                if(especialidadElim.materiales && especialidadElim.materiales.length > 0){
                    for(let material of especialidadElim.materiales){                    
                        var dat2 = await api.get('trabajos/' + material.id_trabajo);
                        var datosTrabajo2 = dat2.datos;
                        var tipo2 = 'cliente';
                        if(datosTrabajo2.destinatario_trabajo != 'Compañia' && datosTrabajo2.destinatario_trabajo != ''){
                            tipo = 'opera';
                        }
                        let subidadatos = { baremos_trabajos_id_trabajo: 0, quitar_baremo: 1 };
                        await api.put('trabajos/' + material.id_trabajo + '/modificar-trabajo', subidadatos);
                        console.log('tipo', tipo2);
                        this.$parent.togglerecargar(datosTrabajo2, true, false, tipo2);
                    }
                }
                if(especialidadElim.desplazamiento && especialidadElim.desplazamiento.length > 0){
                    for(let desplazamiento of especialidadElim.desplazamiento){
                        var dat3 = await api.get('trabajos/' + desplazamiento.id_trabajo);
                        var datosTrabajo3 = dat3.datos;
                        var tipo3 = 'cliente';
                        if(datosTrabajo3.destinatario_trabajo != 'Compañia' && datosTrabajo3.destinatario_trabajo != ''){
                            tipo = 'opera';
                        }
                        let subidadatos = { baremos_trabajos_id_trabajo: 0, quitar_baremo: 1 };
                        await api.put('trabajos/' + desplazamiento.id_trabajo + '/modificar-trabajo', subidadatos);
                        console.log('tipo', tipo3);
                        this.$parent.togglerecargar(datosTrabajo3, true, false, tipo3);
                    }
                }
                console.log('llegavareca');
                this.cargarTrabajos();
            }catch(e){
                this.$toast.add({severity:'error', summary: 'Error', detail: e, life: 5000});
                console.error(e);
            }
        },

        //enviamos el presupuesto temporal
        async guardarPresupuesto(grupoAfectado){
            this.cargandoTemporales = true;
            const api = new PwgsApi();  
            var envio = {
                TipoOperacion:"MANAGE_PREVAL",
                TipoPrepVal:"P",
                IdEncargo:"",
                IdAfectado:grupoAfectado.idAfectado,
                Oficios:[],
            }
            var total = 0;
            grupoAfectado.presupuestosTemporales.forEach(presupuesto => {
                var oficio = {
                    IdEspecialidad: presupuesto.idEspecialidad,
                    Indice: presupuesto.indice,
                    Comentario: presupuesto.comentario,
                }
                if(presupuesto.trabajos.length > 0){
                    oficio.Trabajos = [];
                    presupuesto.trabajos.forEach(trabajo => {
                        if(trabajo.PresupuestarPor == 'BA'){
                            oficio.PresupuestarPor = 'BA';
                        }else{
                            oficio.PresupuestarPor = 'MO';
                        }
                        if(trabajo.IvaReducido == 'N'){
                            oficio.IvaReducido = 'N';
                        }else{
                            oficio.IvaReducido = 'S';
                        }
                        oficio.IVAOfic = trabajo.IvaSeleccionado;                        
                        var precio2 = trabajo.trabajo.precio;
                        var trabajoOficio = {
                            IdTarifa:trabajo.trabajo.id_tarifa,
                            IdTraOfic:trabajo.trabajo.id_categoria,
                            IdLinea:trabajo.trabajo.id_linea,
                            ClaveLinea:trabajo.trabajo.clave_linea,
                            Cantidad:trabajo.Cantidad.toString().replaceAll('.',','),
                            Precio:precio2.toString().replaceAll('.',','),
                            IVABarMO:trabajo.IvaSeleccionado,
                            Urgente:trabajo.Urgente,
                            TotalConIVABarMO:trabajo.TotalConIva.toString().replaceAll('.',',')
                        }
                        total+=trabajo.TotalConIva;
                        oficio.Trabajos.push(trabajoOficio);
                    });
                }
                if(presupuesto.materiales.length > 0){
                    oficio.Materiales = [];
                    presupuesto.materiales.forEach(material => {
                        var precio = 0;
                        if(material.PresupuestarPor == 'BA'){
                            precio = material.trabajo.precioUnidad;
                            oficio.PresupuestarPor = 'BA';
                        }else{
                            precio = material.trabajo.precioUnidad;
                            oficio.PresupuestarPor = 'MO';
                        }
                        if(material.IvaReducido == 'N'){
                            oficio.IvaReducido = 'N';
                        }else{
                            oficio.IvaReducido = 'S';
                        }
                        oficio.IVAOfic = material.IvaSeleccionado;                        
                        var materialOficio = {
                            IdTarifa:material.trabajo.id_tarifa,
                            IdTraOfic:material.trabajo.id_categoria,
                            IdLinea:material.trabajo.id_linea,
                            ClaveLinea:material.trabajo.clave_linea,
                            Cantidad:material.Cantidad.toString().replaceAll('.',','),
                            Precio:precio.toString().replaceAll(".", ","),
                            IVAMat:material.IvaSeleccionado,
                            Descripcion:material.Descripcion,
                            TotalConIVAMat:material.TotalConIva.toString().replaceAll('.',',')
                        }
                        total+=material.TotalConIva;
                        oficio.Materiales.push(materialOficio);
                    });
                }
                if(presupuesto.desplazamiento.length > 0){
                    var desplaza = presupuesto.desplazamiento[0];
                    
                    oficio.Desplazamiento = {
                        IdTarifa:desplaza.trabajo.id_tarifa,
                        IdTraOfic:desplaza.trabajo.id_categoria,
                        IdLinea:desplaza.trabajo.id_linea,
                        ClaveLinea:desplaza.trabajo.clave_linea,
                        Kms:desplaza.Cantidad,
                        KmsPrecio:desplaza.trabajo.precio.toString().replaceAll(".", ","),
                        IVAKms:desplaza.IvaSeleccionado,
                        TotalConIVAKms:desplaza.TotalConIva.toString().replaceAll('.',',')
                    }
                    total+=desplaza.TotalConIva;
                }
                envio.Oficios.push(oficio);
            });
            total = this.redondear(total);
            //envio.TotalPrepValConIVA = total;
            console.log('envio', envio);
            console.log(total);
             
            try{
                var resp = await api.post('servicios/'+ this.id + '/envio-presuval', {envio:envio}); 
                console.log('respobtenida', resp);
                var presupuesto = resp['RepairEstimateValuationList']['Presupuestos']['ListadoPresupuestos'][0]['Presupuesto'][0];
                console.log('presupuestoobtenido', presupuesto);
                this.$toast.add({severity:'success', summary: 'Creado', detail: 'Presupuesto creado', life: 2000});
                var temporales = await api.get('trabajos/'+ this.id + '/presuval-axa');
                console.log('temporales', temporales);
                var ids = [];
                for(let temporal of temporales){
                    if(temporal.IdAfectado == grupoAfectado.idAfectado && temporal.Enviado == 'N'){
                        ids.push(temporal.id_trabajo);
                    }
                }
                console.log('ids', ids);
                await api.put('trabajos/'+ this.id +'/marcar-enviados', {ids:ids, id_presuval:presupuesto.IdPPTOVAL, version:presupuesto.Version});
                this.cargarTrabajos();
            }catch(e){
                this.$toast.add({severity:'error', summary: 'Error', detail: e, life: 5000});
                this.cargandoTemporales = false;
                console.error(e);
            }
        },
        redondear(value) {
            return Number.isInteger(value)
                ? value
                : parseFloat(value.toFixed(2));
        },
        async cargarTemporales(temporales) {
            this.gruposAfectadosPresupuestosTemporales = [];
            console.log('temporales2', temporales);
            //recorremos los trabajos obtenidos (los conectados con axa, es decir que tienen parametros de env�o)
            temporales.forEach(tempo => {                
                //cogemos solo los presupuestos
                if(tempo.TipoPrepVal == 'P'){                  
                    //buscamos su afectado y especialidad
                    console.log('tempo', tempo);
                    console.log('afectados', this.afectadosPresupuestos);
                    var afectadoEncontrado = this.afectadosPresupuestos.find(afectado => afectado.IdAfectado == tempo.IdAfectado);
                    var especialidadEncontrada = afectadoEncontrado.Especialidades.find(especialidad => especialidad.IdEspecialidad == tempo.IdEspecialidad && especialidad.Indice == tempo.Indice);
                    tempo.TotalConIva = this.redondear(parseFloat(tempo.TotalConIva));
                    tempo.TotalSinIva = this.redondear(parseFloat(tempo.TotalSinIva));
                    var grupoAfectadoEncontrado = undefined;
                    
                    //AGRUPAMOS LOS TRABAJOS POR AFECTADO
                    
                    if(especialidadEncontrada != undefined){                     
                        //si no hay ningun grupo de afectados, creamos uno
                        if(this.gruposAfectadosPresupuestosTemporales.length == 0){
                            var grupoAfectadoTemporal = {
                                afectado: afectadoEncontrado.NombreAfectado,
                                idAfectado: afectadoEncontrado.IdAfectado,
                                presupuestosTemporales: [],
                            }
                            this.gruposAfectadosPresupuestosTemporales.push(grupoAfectadoTemporal);
                            grupoAfectadoEncontrado = this.gruposAfectadosPresupuestosTemporales[0];
                            console.log('llegacrea');
                        }else{
                            //si hay alguno ya creado, buscamos el que corresponda
                            grupoAfectadoEncontrado = this.gruposAfectadosPresupuestosTemporales.find(afectado => afectado.idAfectado == tempo.IdAfectado);
                            console.log('llegaencuentra', this.gruposAfectadosPresupuestosTemporales, grupoAfectadoEncontrado);
                        }
                        // si no hay un grupo de su afectado, lo creamos
                        if(grupoAfectadoEncontrado == undefined){
                            var grupoAfectadoTemporal2 = {
                                afectado: afectadoEncontrado.NombreAfectado,
                                idAfectado: afectadoEncontrado.IdAfectado,
                                presupuestosTemporales: [],
                            }
                            this.gruposAfectadosPresupuestosTemporales.push(grupoAfectadoTemporal2);
                            grupoAfectadoEncontrado = this.gruposAfectadosPresupuestosTemporales[this.gruposAfectadosPresupuestosTemporales.length-1];
                        }
                        
                        //ya tenemos el grupo de afectado al que pertenece, ahora agrupamos de este grupo por su especialidad
    
                        //si el grupo de afectado al que pertenece no tiene ningun presupuesto, creamos uno
                        if(grupoAfectadoEncontrado.presupuestosTemporales.length == 0){                          
                            console.log('afectadoEncontrado', afectadoEncontrado);                      
                            console.log('especialidadEncontrada', especialidadEncontrada);
                            var grupoPresupuestoTemporal = {
                                especialidad: especialidadEncontrada.NombreEspecialidad,
                                idEspecialidad: especialidadEncontrada.IdEspecialidad,
                                indice:especialidadEncontrada.Indice,
                                totalBaremo:0,
                                totalMateriales:0,
                                totalDesplazamiento:0,
                                totalIva:0,
                                total:0,
                                trabajos: [],
                                materiales: [],
                                desplazamiento:[],
                                comentario:'',
                            };
                            if(tempo.PresupuestarPor == "BA"){
                                grupoPresupuestoTemporal.presupuestarPor = "baremo";
                            }else{
                                grupoPresupuestoTemporal.presupuestarPor = "M.O.";
                            }
                            if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                grupoPresupuestoTemporal.totalBaremo = tempo.TotalConIva;
                                grupoPresupuestoTemporal.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                          
                                grupoPresupuestoTemporal.total = tempo.TotalConIva;
                                grupoPresupuestoTemporal.trabajos.push(tempo);
                            }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                grupoPresupuestoTemporal.totalMateriales = tempo.TotalConIva;
                                grupoPresupuestoTemporal.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                grupoPresupuestoTemporal.total = tempo.TotalConIva;
                                grupoPresupuestoTemporal.materiales.push(tempo);
                            }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                grupoPresupuestoTemporal.totalDesplazamiento = tempo.TotalConIva;
                                grupoPresupuestoTemporal.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                                
                                grupoPresupuestoTemporal.total =  tempo.TotalConIva;
                                grupoPresupuestoTemporal.desplazamiento.push(tempo);
                            }
                           
                            grupoAfectadoEncontrado.presupuestosTemporales.push(grupoPresupuestoTemporal);
                        //Si el grupo de afectado al que pertenece ya tiene algun presupuesto, miramos si hay un grupo para la especialidad en concreto
                        }else{
                            var grupoEncontrado = grupoAfectadoEncontrado.presupuestosTemporales.find(grupo => grupo.idEspecialidad == tempo.IdEspecialidad && grupo.indice == tempo.Indice);
                            //si existe el grupo de especialidad del trabajo lo a�adimos aqu�
                            if(grupoEncontrado){
                                console.log('grupoEncontrado', grupoEncontrado);
                                if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                    grupoEncontrado.totalBaremo = grupoEncontrado.totalBaremo+tempo.TotalConIva;
                                    grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                    grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                    grupoEncontrado.trabajos.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                    grupoEncontrado.totalMateriales = grupoEncontrado.totalMateriales+tempo.TotalConIva;
                                    grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                    grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                    grupoEncontrado.materiales.push(tempo);
                                }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                    grupoEncontrado.totalDesplazamiento = grupoEncontrado.totalDesplazamiento+tempo.TotalConIva;
                                    grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                    grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                    grupoEncontrado.desplazamiento.push(tempo);
                                }
                            //si no existe el grupo de especialidad del trabajo lo creamos
                            }else{
                                var afectadoEncontrado2 = this.afectadosPresupuestos.find(afectado => afectado.IdAfectado == tempo.IdAfectado);
                                var especialidadEncontrada2 = afectadoEncontrado2.Especialidades.find(especialidad => especialidad.IdEspecialidad == tempo.IdEspecialidad && especialidad.Indice == tempo.Indice);
                                var grupoPresupuestoTemporal2 = {
                                    especialidad: especialidadEncontrada2.NombreEspecialidad,
                                    idEspecialidad: especialidadEncontrada2.IdEspecialidad,
                                    indice : especialidadEncontrada2.Indice,
                                    totalBaremo:0,
                                    totalMateriales:0,
                                    totalDesplazamiento:0,
                                    totalIva:0,
                                    total:0,
                                    trabajos: [],
                                    materiales: [],
                                    desplazamiento: [],
                                    comentario:'',
                                };
                                if(tempo.PresupuestarPor == "BA"){
                                    grupoPresupuestoTemporal2.presupuestarPor = "baremo";
                                }else{
                                    grupoPresupuestoTemporal2.presupuestarPor = "M.O.";
                                }
                                if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                    grupoPresupuestoTemporal2.totalBaremo = tempo.TotalConIva;
                                    grupoPresupuestoTemporal2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                    grupoPresupuestoTemporal2.total = tempo.TotalConIva;
                                    grupoPresupuestoTemporal2.trabajos.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                    grupoPresupuestoTemporal2.totalMateriales = tempo.TotalConIva;
                                    grupoPresupuestoTemporal2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                    grupoPresupuestoTemporal2.total = tempo.TotalConIva;
                                    grupoPresupuestoTemporal2.materiales.push(tempo);
                                }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                    grupoPresupuestoTemporal2.totalDesplazamiento = tempo.TotalConIva;
                                    grupoPresupuestoTemporal2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                    grupoPresupuestoTemporal2.total = tempo.TotalConIva;
                                    grupoPresupuestoTemporal2.desplazamiento.push(tempo);
                                }
                                grupoAfectadoEncontrado.presupuestosTemporales.push(grupoPresupuestoTemporal2);
                            }
                        }
                    }
                }
                
            });
            console.log('gruposAfectadis', this.gruposAfectadosPresupuestosTemporales);
            this.gruposAfectadosPresupuestosTemporales.forEach(grupo => {
                grupo.presupuestosTemporales.forEach(presupuesto => {
                    presupuesto.totalBaremo = parseFloat(presupuesto.totalBaremo).toFixed(2);
                    presupuesto.totalMateriales = parseFloat(presupuesto.totalMateriales).toFixed(2);
                    presupuesto.totalDesplazamiento = parseFloat(presupuesto.totalDesplazamiento).toFixed(2);
                    presupuesto.total = parseFloat(presupuesto.total).toFixed(2);
                    presupuesto.totalIva = parseFloat(presupuesto.totalIva).toFixed(2);
                })
            })
            this.cargandoTemporales = false;
        },
        async cargarCreados(creados){
            try{
                const api = new PwgsApi();
                this.gruposAfectadosPresupuestosCreados = [];
                console.log('temporales2', creados);
                //recorremos los trabajos obtenidos (los conectados con axa, es decir que tienen parametros de env�o)
                if(creados && creados.length>0){
                    var datosPresupuestos = await api.post('servicios/' + this.id + '/obtenerPresuval',  {tipo:'P'});
                }            
                creados.forEach(tempo => {      
                    //cogemos solo los presupuestos
                    if(tempo.TipoPrepVal == 'P'){                  
                        var presupuestosAxa = datosPresupuestos.RepairEstimateValuationList.Presupuestos.ListadoPresupuestos[0].Presupuesto;          
                        //buscamos su afectado y especialidad
                        var afectadoEncontrado = this.afectadosPresupuestos.find(afectado => afectado.IdAfectado == tempo.IdAfectado);
                        var especialidadEncontrada = afectadoEncontrado.Especialidades.find(especialidad => especialidad.IdEspecialidad == tempo.IdEspecialidad && especialidad.Indice == tempo.Indice);
                        console.log('tempo', tempo);
                        tempo.TotalConIva = this.redondear(parseFloat(tempo.TotalConIva));
                        tempo.TotalSinIva = this.redondear(parseFloat(tempo.TotalSinIva));
                        var grupoAfectadoEncontrado = undefined;
                        
                        //AGRUPAMOS LOS TRABAJOS POR AFECTADO    
                        if(especialidadEncontrada != undefined){
                            //si no hay ningun grupo de afectados, creamos uno
                            if(this.gruposAfectadosPresupuestosCreados.length == 0){
                                var grupoAfectadoTemporal = {
                                    afectado: afectadoEncontrado.NombreAfectado,
                                    idAfectado: afectadoEncontrado.IdAfectado,
                                    presupuestosCreados: [],
                                }
                                this.gruposAfectadosPresupuestosCreados.push(grupoAfectadoTemporal);
                                grupoAfectadoEncontrado = this.gruposAfectadosPresupuestosCreados[0];
                                console.log('llegacrea');
                            }else{
                                //si hay alguno ya creado, buscamos el que corresponda
                                grupoAfectadoEncontrado = this.gruposAfectadosPresupuestosCreados.find(afectado => afectado.idAfectado == tempo.IdAfectado);
                                console.log('llegaencuentra', this.gruposAfectadosPresupuestosCreados, grupoAfectadoEncontrado);
                            }
                            // si no hay un grupo de su afectado, lo creamos
                            if(grupoAfectadoEncontrado == undefined){
                                var grupoAfectadoTemporal2 = {
                                    afectado: afectadoEncontrado.NombreAfectado,
                                    idAfectado: afectadoEncontrado.IdAfectado,
                                    presupuestosCreados: [],
                                }
                                this.gruposAfectadosPresupuestosCreados.push(grupoAfectadoTemporal2);
                                grupoAfectadoEncontrado = this.gruposAfectadosPresupuestosCreados[this.gruposAfectadosPresupuestosCreados.length-1];
                            }
                            
                            //ya tenemos el grupo de afectado al que pertenece, ahora agrupamos de este grupo por su presupuesto
        
                            //si el grupo de afectado al que pertenece no tiene ningun presupuesto, creamos uno
                            var grupoPresupuestoEncontrado = undefined;
                            var presupuestoAxaEncontrado = presupuestosAxa.find(presupuesto => presupuesto.IdPPTOVAL == tempo.id_presuval && presupuesto.Version == tempo.version);                     
                            console.log('presuaxa', presupuestoAxaEncontrado);
                            if(grupoAfectadoEncontrado.presupuestosCreados.length == 0){   
                                var grupoPresupuestoCreado = {
                                    tiene_visita:false,
                                    tiene_desp:false,
                                    tipo_encargo:'normal',
                                    id_presupuesto: tempo.id_presuval,
                                    version: tempo.version,
                                    estado: presupuestoAxaEncontrado.Estado,
                                    id_estado: presupuestoAxaEncontrado.IdEstado,
                                    total: presupuestoAxaEncontrado.TotalPPTO,
                                    especialidades:[],
                                }
                                console.log('presuaxaenc', presupuestoAxaEncontrado);
                                presupuestoAxaEncontrado.Oficios.forEach(oficio => {
                                    console.log('entraoficio', oficio);
                                    if(oficio.TotalVisita != '0' && oficio.TotalVisita != '0,00'){
                                        grupoPresupuestoCreado.tiene_visita = true;
                                    }
                                })
    
                                if(presupuestoAxaEncontrado.TipoEncargo.includes('particular')){
                                    grupoPresupuestoCreado.tipo_encargo = 'particular';
                                }
                                grupoAfectadoEncontrado.presupuestosCreados.push(grupoPresupuestoCreado);
                                grupoPresupuestoEncontrado = grupoAfectadoEncontrado.presupuestosCreados[0];
                            //si el grupo de afectado al que pertenece tiene al menos un presupuesto buscamos el suyo
                            }else{
                                console.log('llegaelse', grupoAfectadoEncontrado, especialidadEncontrada);
                                grupoPresupuestoEncontrado = grupoAfectadoEncontrado.presupuestosCreados.find(grupo => grupo.id_presupuesto == tempo.id_presuval && grupo.version == tempo.version);
                            }
        
                            //si no hay un grupo de presupuesto al que pertenece, lo creamos
                            if(grupoPresupuestoEncontrado == undefined){                        
                                var grupoPresupuestoCreado2 = {
                                    tiene_visita:false,
                                    tiene_desp:false,
                                    tipo_encargo:'normal',
                                    id_presupuesto: tempo.id_presuval,
                                    version: tempo.version,
                                    estado: presupuestoAxaEncontrado.Estado,
                                    id_estado: presupuestoAxaEncontrado.IdEstado,
                                    total: presupuestoAxaEncontrado.TotalPPTO,
                                    especialidades:[],
                                }
                                if(presupuestoAxaEncontrado.TipoEncargo.includes('particular')){
                                    grupoPresupuestoCreado2.tipo_encargo = 'particular';
                                }
                                presupuestoAxaEncontrado.Oficios.forEach(oficio => {
                                    if(oficio.TotalVisita != '0' && oficio.TotalVisita != '0,00'){
                                        grupoPresupuestoCreado2.tiene_visita = true;
                                    }
                                })
                                grupoAfectadoEncontrado.presupuestosCreados.push(grupoPresupuestoCreado2);
                                grupoPresupuestoEncontrado = grupoAfectadoEncontrado.presupuestosCreados[grupoAfectadoEncontrado.presupuestosCreados.length-1];
                            }
        
                            //ya tenemos el grupo de presupuesto al que pertenece, ahora agrupamos de este grupo por su especialidad
        
                            //si el grupo de presupuesto al que pertenece no tiene ningun grupo de especialidad, creamos uno
                            var especialidadesAxa = presupuestoAxaEncontrado.Oficios;
                            console.log('especialidades', especialidadesAxa, especialidadEncontrada);
                            var especialidadAxaEncontrada = especialidadesAxa.find(especialidad => especialidad.IdEspecialidad == especialidadEncontrada.IdEspecialidad && especialidad.IndiceEspecialidad == especialidadEncontrada.Indice);
                            console.log('especialidadAxaEncontrada', especialidadAxaEncontrada);
                            if(grupoPresupuestoEncontrado.especialidades.length == 0){                          
                                var grupoEspecialidadCreada= {
                                    especialidad: especialidadEncontrada.NombreEspecialidad,
                                    idEspecialidad: especialidadEncontrada.IdEspecialidad,
                                    indice:especialidadEncontrada.Indice,
                                    totalBaremo:0,
                                    totalMateriales:0,
                                    totalDesplazamiento:0,
                                    totalIva:0,
                                    total:0,
                                    trabajos: [],
                                    materiales: [],
                                    desplazamiento:[],
                                    comentario: especialidadAxaEncontrada.Comentario,
                                    idProfesion: especialidadAxaEncontrada.IdProfesion,
                                };
                                if(tempo.PresupuestarPor == "BA"){
                                    grupoEspecialidadCreada.presupuestarPor = "baremo";
                                }else{
                                    grupoEspecialidadCreada.presupuestarPor = "M.O.";
                                }
                                if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                    grupoEspecialidadCreada.totalBaremo = tempo.TotalConIva;
                                    grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                    grupoEspecialidadCreada.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada.trabajos.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                    grupoEspecialidadCreada.totalMateriales = tempo.TotalConIva;
                                    grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                    grupoEspecialidadCreada.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada.materiales.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Desplazamiento'){
                                    grupoEspecialidadCreada.totalDesplazamiento = tempo.TotalConIva;
                                    grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                    grupoEspecialidadCreada.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada.desplazamiento.push(tempo);
                                }
                               
                                grupoPresupuestoEncontrado.especialidades.push(grupoEspecialidadCreada);
                            //Si el grupo de presupuesto al que pertenece ya tiene algun grupo de epecialidad, miramos si hay un grupo para la especialidad en concreto
                            }else{
                                var grupoEncontrado = grupoPresupuestoEncontrado.especialidades.find(grupo => grupo.idEspecialidad == tempo.IdEspecialidad && grupo.indice == tempo.Indice);
                                //si existe el grupo de especialidad del trabajo lo a�adimos aqu�
                                if(grupoEncontrado){
                                    console.log('grupoEncontrado', grupoEncontrado);
                                    if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                        grupoEncontrado.totalBaremo = grupoEncontrado.totalBaremo+tempo.TotalConIva;
                                        grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                        grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                        grupoEncontrado.trabajos.push(tempo);
                                    }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                        grupoEncontrado.totalMateriales = grupoEncontrado.totalMateriales+tempo.TotalConIva;
                                        grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                        grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                        grupoEncontrado.materiales.push(tempo);
                                    }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                        grupoEncontrado.totalDesplazamiento = grupoEncontrado.totalDesplazamiento+tempo.TotalConIva;
                                        grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                        grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                        grupoEncontrado.desplazamiento.push(tempo);
                                    }
                                //si no existe el grupo de especialidad del trabajo lo creamos
                                }else{                            
                                    var grupoEspecialidadCreada2= {
                                        especialidad: especialidadEncontrada.NombreEspecialidad,
                                        idEspecialidad: especialidadEncontrada.IdEspecialidad,
                                        indice:especialidadEncontrada.Indice,
                                        totalBaremo:0,
                                        totalMateriales:0,
                                        totalDesplazamiento:0,
                                        totalIva:0,
                                        total:0,
                                        trabajos: [],
                                        materiales: [],
                                        desplazamiento:[],
                                        comentario: especialidadAxaEncontrada.Comentario,
                                        idProfesion: especialidadAxaEncontrada.IdProfesion,
                                    };
                                    if(tempo.PresupuestarPor == "BA"){
                                        grupoEspecialidadCreada2.presupuestarPor = "baremo";
                                    }else{
                                        grupoEspecialidadCreada2.presupuestarPor = "M.O.";
                                    }
                                    if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                        grupoEspecialidadCreada2.totalBaremo = tempo.TotalConIva;
                                        grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                        grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                        grupoEspecialidadCreada2.trabajos.push(tempo);
                                    }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                        grupoEspecialidadCreada2.totalMateriales = tempo.TotalConIva;
                                        grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                        grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                        grupoEspecialidadCreada2.materiales.push(tempo);
                                    }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                        grupoEspecialidadCreada2.totalDesplazamiento = tempo.TotalConIva;
                                        grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                        grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                        grupoEspecialidadCreada2.desplazamiento.push(tempo);
                                    }
                                    grupoPresupuestoEncontrado.especialidades.push(grupoEspecialidadCreada2);
                                }
                            }
                        }

                    }
                    
                });
                console.log('gruposAfectadis', this.gruposAfectadosPresupuestosCreados);
                this.gruposAfectadosPresupuestosCreados.forEach(grupo => {
                    grupo.presupuestosCreados.forEach(presupuesto => {
                        presupuesto.especialidades.forEach(especialidad => {
                            console.log('especialidad', especialidad);
                            especialidad.totalBaremo = parseFloat(especialidad.totalBaremo).toFixed(2);
                            especialidad.totalMateriales = parseFloat(especialidad.totalMateriales).toFixed(2);
                            especialidad.totalDesplazamiento = parseFloat(especialidad.totalDesplazamiento).toFixed(2);
                            especialidad.total = parseFloat(especialidad.total).toFixed(2);
                            especialidad.totalIva = parseFloat(especialidad.totalIva).toFixed(2);
                            if(especialidad.desplazamiento.length > 0){
                                presupuesto.tiene_desp = true;
                            }
                        })
                    })
                })
            }catch(e){
                this.$toast.add({ severity: 'error', summary: "Error", detail: e, life: 5000 });
                console.error(e);
            }
            this.cargandoCreados = false;
        },
        async cargarTrabajos() {
            console.log('llegareca');
            this.cargandoTemporales = true;
            this.cargandoCreados = true;
            const api = new PwgsApi();
            var datos = await api.post('servicios/' + this.id + '/oficios');
            var trabajos = await api.get('trabajos/'+ this.id + '/presuval-axa');
            if(!trabajos) trabajos = [];
            var temporales = trabajos.filter(trabajo => trabajo.Enviado != 'S');
            var creados = trabajos.filter(trabajo => trabajo.Enviado == 'S');
            if(datos.RepairEstimateValuationList){
                this.afectadosPresupuestos = datos.RepairEstimateValuationList.Presupuestos.OficiosAfectado[0].Afectado;
                this.cargarTemporales(temporales);
                this.cargarCreados(creados);
            }else{
                this.cargandoCreados = false;
                this.cargandoTemporales = false;
            }
        },
    },
    watch: {
    },
};
</script>

<style scoped>
.container{
    display: grid;
    overflow: auto;
    height: 600px;
}
</style>